import React, { useEffect, useState } from "react";
import {
  UmbracoChildren,
  UmbracoStep,
  UmbracoStepChildren,
} from "components/Umbraco/UmbracoContext";
import utils from "utils";
import {
  Label,
  Line,
  RowCenter,
  LineSmall,
  StepBody,
  StepFooter,
  ToggleGroup,
  UploadFile,
  useInput,
  Spinner,
  Row,
} from "meitav-uikit";
import {
  postData,
  setDataLayer,
  uploadFilesToBack,
} from "../../../../../utils/Functions";
import FileItem from "./FileItem";
import "./step43.scss";
import Footer from "components/Footer";
import { Parser } from "html-to-react";

const { UmbracoUtills, rest } = utils;

export default function Step43({
  resource,
  model,
  setStep,
  step,
  dataList,
  setDataList,
  nextText,
  disable,
}) {
  const resourceStep = UmbracoStep(resource, `ThirdSub3Step`);
  const fileItems = UmbracoChildren(resource, `ThirdSub3Step`);

  const [fileList, setFileList] = useState(dataList.digitalFile.fileList || []);
  const [partnerFiles, setPartnerFiles] = useState(
    dataList.digitalFile.partnerFiles || []
  );

  const p = new Parser();
  const [showSpinner, setShowSpinner] = useState(true);

  useEffect(() => {
    addFileList();
  }, []);

  const addFileList = async () => {
    let tmpPartner = {};
    let tmp = {};

    fileItems.forEach((item) => {
      if (UmbracoUtills.getCheckbox(item, "asInvestPartner")) {
        let fileTypeID = UmbracoUtills.getValueByKey(item, "fileTypeID");
        tmpPartner[fileTypeID] = {};
        tmpPartner[fileTypeID].name = UmbracoUtills.getValueByKey(
          item,
          "title"
        );
        tmpPartner[fileTypeID].file = "";
        if (partnerFiles[fileTypeID] && partnerFiles[fileTypeID].file) {
          tmpPartner[fileTypeID].file = partnerFiles[fileTypeID].file;
        }
      } else {
        let fileTypeID = UmbracoUtills.getValueByKey(item, "fileTypeID");
        tmp[fileTypeID] = {};
        tmp[fileTypeID].name = UmbracoUtills.getValueByKey(item, "title");
        tmp[fileTypeID].file = "";
        if (fileList[fileTypeID] && fileList[fileTypeID].file) {
          tmp[fileTypeID].file = fileList[fileTypeID].file;
        }
      }
    });
    setFileList(tmp);
    setPartnerFiles(tmpPartner);
    setShowSpinner(false);
  };
  const handleNext = async () => {
    if (disable) {
      setStep(99);
      return;
    }
    setDataLayer(
      "PM - Upload files",
      window.location.pathname,
      "העלאת קבצים",
      "המשך מוצלח של שלב העלאת קבצים"
    );

    let tmpData = dataList;
    tmpData.digitalFile.fileList = fileList;
    tmpData.digitalFile.partnerFileList = partnerFiles;

    setDataList(tmpData);
    localStorage.setItem("dataList", JSON.stringify(tmpData));

    checkMissingFile();
    uploadFiles();

    let tmpModel = model;
    tmpModel.currentStepID = 43;
    tmpModel.stepID = 99;
    postData(tmpModel, setStep);
  };

  const checkMissingFile = async () => {
    let tmp = [];

    Object.keys(fileList).map(function (key) {
      if (fileList[key].file == "") {
        tmp.push(fileList[key].name);
      }
    });

    let tmpData = dataList;
    tmpData.missingFileList = tmp;
    tmpData.missingFile = tmp.length > 0;
    setDataList(tmpData);
    localStorage.setItem("dataList", JSON.stringify(tmpData));
  };

  const uploadFiles = async () => {
    let list = {};

    Object.keys(fileList).map(function (key) {
      if (fileList[key].file != "") {
        list[key] = fileList[key].file;
      }
    });
    Object.keys(partnerFiles).map(function (key) {
      if (partnerFiles[key].file != "") {
        list[key] = partnerFiles[key].file;
      }
    });
    if (list != null) uploadFilesToBack(list);
  };

  const handlePrev = async () => {
    setDataLayer(
      "PM - Levels",
      "/JoinPersonalDetails",
      "חזור לשלב הקודם",
      "חזרה - " + step
    );

    let tmpModel = model;
    let tmpDataList = dataList;
    dataList.digitalFile.fileList = fileList;
    dataList.digitalFile.partnerFileList = partnerFiles;

    setDataList(tmpDataList);
    localStorage.setItem("dataList", JSON.stringify(tmpDataList));

    if (tmpModel?.sectorCode == 6) {
      setStep(44);
    } else {
      setStep(42);
    }
  };

  return (
    <div className="step43">
      <StepBody>
        <Line>
          {fileItems.length &&
            fileItems.map((item, i) => (
              <>
                {!UmbracoUtills.getCheckbox(item, "asInvestPartner") && (
                  <FileItem
                    disable={disable}
                    key={i}
                    item={item}
                    fileList={fileList}
                    setFileList={setFileList}
                  />
                )}
              </>
            ))}
        </Line>

        {model?.mainUser?.asInvestPartner == true &&
        model?.mainUser?.commonBankAccount == true ? (
          <Row>
            <Line>
              <Label className="font17 mr-4 mb-2">
                {UmbracoUtills.getParsedHtmlValueByKey(
                  resourceStep,
                  "textPartner"
                )}
                {`${model?.bankPartner?.firstName} ${model?.bankPartner?.lastName} ת.ז ${model?.bankPartner?.taz}`}
              </Label>
            </Line>
            <Line>
              {fileItems.length &&
                fileItems.map((item, i) => (
                  <>
                    {UmbracoUtills.getCheckbox(item, "asInvestPartner") && (
                      <FileItem
                        disable={disable}
                        key={i}
                        item={item}
                        fileList={partnerFiles}
                        setFileList={setPartnerFiles}
                      />
                    )}
                  </>
                ))}
            </Line>
          </Row>
        ) : null}
      </StepBody>
      <StepFooter
        nextText={nextText}
        handleNext={handleNext}
        handlePrev={handlePrev}
      />
      <Footer
        text={p.parse(UmbracoUtills.getValueByKey(resourceStep, "mainText"))}
      ></Footer>
    </div>
  );
}
